module.exports = __webpack_public_path__ + "img/icon-filter-light-blue.e4d6404c.svg";